
/**
 * 
 * Scrolls the element into view if it is not already in view.
 * Only scrolls the element into view once.
 */
export function scrollIntoView<T extends HTMLElement>(element: T) {
    // make sure element is still in dom
    if (!element) return;
    // make sure we haven't already scrolled this element
    if (element?.hasAttribute("data-already-scrolled")) return;

    element.scrollIntoView({ behavior: "smooth", block: "center" });
    element?.setAttribute("data-already-scrolled", "true");
}

// get page at the end of the url, remove any url params
export const getPageSlug = (url: string): string => {
    const page = url.split("/").pop();
    return page.split("?")[0];
};